import { render } from "./idCardUploadWay.vue?vue&type=template&id=c441c94c"
import script from "./idCardUploadWay.vue?vue&type=script&lang=js"
export * from "./idCardUploadWay.vue?vue&type=script&lang=js"

import "./idCardUploadWay.vue?vue&type=style&index=0&id=c441c94c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\DTP\\dtp_index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__